/**
 * Modal de un solo uso para mostrar un secreto que el API nunca vuelve a devolver (secreto de
 * cliente OAuth confidencial, secreto de endpoint de webhook — docs/FASE-1.md §6: "el secreto se
 * muestra una sola vez, con aviso explícito"). No persiste el valor en ningún sitio (ni
 * `localStorage` ni `sessionStorage`): vive solo en el estado de React del componente que lo
 * recibió de la respuesta del API, y desaparece al cerrar este modal.
 */
import { useState, type ReactElement } from "react";

import { Modal } from "./Modal";

export function SecretReveal({ title, secret, onClose }: { title: string; secret: string; onClose: () => void }): ReactElement {
  const [copied, setCopied] = useState(false);

  async function handleCopy(): Promise<void> {
    try {
      await navigator.clipboard.writeText(secret);
      setCopied(true);
    } catch {
      setCopied(false);
    }
  }

  return (
    <Modal title={title} onClose={onClose}>
      <p className="field-error" role="alert">
        Este valor no se volverá a mostrar. Cópialo y guárdalo en un lugar seguro antes de cerrar esta ventana.
      </p>
      <pre className="secret-box">{secret}</pre>
      <div className="form-actions">
        <button type="button" className="button-secondary" onClick={() => void handleCopy()}>
          {copied ? "Copiado" : "Copiar"}
        </button>
        <button type="button" className="button-primary" onClick={onClose}>
          Ya lo guardé, cerrar
        </button>
      </div>
    </Modal>
  );
}
